module.exports = __webpack_public_path__ + "img/肉桂.22ece193.jpg";